export default function selectProductFromURLParam(viewmodel) {
    const urlParams = new URLSearchParams(location.search),
        param = 'sku';

    if (!urlParams.has(param)) {
        return;
    }

    const sku = +urlParams.get(param);

    if (viewmodel.type() === 'supplement') {
        viewmodel.selectedProductId(sku);
        return;
    }

    if (viewmodel.type() === 'tes') {
        const product = viewmodel.products().find(product => product.id() === +sku);

        if (!product) {
            return;
        }

        viewmodel.selectedProduct(product);

        if (viewmodel.hasAttributes) {
            viewmodel.attributes.forEach(attribute => {
                const entries = Object.entries(product.attributes).find(([key]) => key === attribute.key);

                if (entries.length) {
                    attribute.selected(Object.fromEntries([entries])[attribute.key]());
                }
            });
        }
    }
}